import client from './client';
import type { Notification } from '../types/notification';

export async function getNotifications(): Promise<Notification[]> {
  const { data } = await client.get('/notifications');
  return data || [];
}

export async function markAsRead(id: string): Promise<void> {
  await client.patch(`/notifications/${id}/read`);
}

export async function getUnreadCount(): Promise<number> {
  const { data } = await client.get('/notifications/unread-count');
  return data?.count ?? 0;
}
